<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    placeholder="Please choose vertical"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.title"
      :value="item.id"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, computed, watch, ref } from 'vue'
import { useVerticalsStore } from '@/store/modules/verticals'
import { IVertical } from '@/api/verticals'

export default defineComponent({
  name: 'VerticalSelector',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const verticalsStore = useVerticalsStore()
    verticalsStore.GetItems()

    const value = ref((props.modelValue || '').toString())
    const options = computed(() => verticalsStore.forSelector)

    const update = (newValue: string) => {
      context.emit('update:modelValue', Number(newValue))
    }

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal.toString()
      }
    )

    return { update, options, value }
  }
})
</script>
